module.exports = __webpack_public_path__ + "media/landing_page/hero-mobile-5-a2c91805.jpg";